export default class userprofile {
    constructor(username, password,lastname,firstname,preference) {
        this.firstname=firstname;
        this.lastname=lastname;
        this.username = username;
        this.password = password;
        this.preference=preference;
    };
}
